import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../config/firebaseConfig";
import { doc, setDoc, collection, query, where, getDocs } from "firebase/firestore";
import { useToast } from "../../util/ToastProvider";

export default function VerifyEmailPage() {
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("Thank you! Your email address has been successfully verified. Please return to the login page to access your account.");
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    const verify = async () => {
      const params = new URLSearchParams(window.location.search);
      const email = params.get("email");

      if (!email) {
        setStatus("error");
        setMessage("⚠️ This link is invalid or expired.");
        return;
      }

      try {
        // 🔍 Check if user exists in Firestore
        console.log("email----->", email)
      }catch (error: any) {
        console.error('❌ Error saving admin:', error.message)
        toast.error( error.message || '❌ Error saving admin:')
      } finally {
        
      }
    };

    verify();
  }, []);

  return (
    <div className="max-w-md mx-auto mt-20 rounded-2xl  p-8 shadow ring-1 ring-slate-200">
      <h1 className="text-lg font-semibold text-white">Email Verification</h1>
      <p
        className={`mt-4 text-sm ${
          status === "success"
            ? "text-green-600"
            : status === "error"
            ? "text-red-600"
            : "text-white"
        }`}
      >
        {message}
      </p>


      <div className="mt-4 text-sm text-slate-600 text-center">
        <a href="/auth/login" className="text-indigo-600 font-medium">
          Back to Login
        </a>
      </div>
    </div>
  );
}
